import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateProjectSettings } from "../../api/apiProjectSettings";
import { useTranslation } from "react-i18next";

export function useUpdateProjectSettings() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");

    const { mutate: updateProjectSettingsMutate, isPending } = useMutation({
        mutationFn: updateProjectSettings,
        onSuccess: () => {
            toast.success(isArabic ? "تم تحديث إعدادات المشاريع بنجاح" : "Project settings updated successfully");
            queryClient.invalidateQueries({ queryKey: ["project-settings"] });
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || err.message);
        },
    });

    return { updateProjectSettingsMutate, isPending };
}
